/**
 * HeidiSettingsButton - Static Heidi logo icon.
 * Used in FloatingAskHeidiInput as a visual indicator.
 */

import { HeidiLogoMark } from '@heidi/design-system/heidi-logo-mark';
import { memo } from 'react';

export const HeidiSettingsButton = memo(() => {
  return (
    <div className="shrink-0">
      {/* theme-agnostic: brand sunlight accent on the Heidi mark, the same yellow in both themes */}
      <HeidiLogoMark aria-label="Heidi" className="size-5 text-sunlight-500" />
    </div>
  );
});

HeidiSettingsButton.displayName = 'HeidiSettingsButton';
